import React from "react";
import { TbAlertTriangleFilled } from "react-icons/tb";

function Violations({ violations = [], className = "", heading, tone = "danger" }) {
	if (violations.length) {
		const toneClass = tone === "warning" ? "bg-warning text-warningText" : "bg-danger text-dangerText";
		return (
			<div className={`${toneClass} p-4 text-xs rounded-md ${className}`}>
				<h5 className="mb-2 align-center">
					<TbAlertTriangleFilled className="mr-2" />
					{heading || `${violations.length} Policy Violations`}
				</h5>
				{violations.map((violation, index) => {
					return (
						<div key={index} className="">
							{index + 1}) {violation}
						</div>
					);
				})}
			</div>
		);
	}

	return null;
}

export default Violations;
